import { Button, Typography } from "@mui/material";
import CustomDialog from "../../../commons/dialog/customDialog";
import { StyledDialog } from "../../../styled/dialog";
import { StyledFormHeader, StyledIdrConfirmDialog } from "../../../styled/form";

const IdrConfirmDialog = ({
  handleClose,
  open,
  title,
  text,
  handleSubmit,
  form,
}) => {
  return (
    <CustomDialog open={open} onClose={handleClose}>
      <StyledIdrConfirmDialog.TitleContainer>
        <Typography sx={StyledFormHeader.text}>{title}</Typography>
      </StyledIdrConfirmDialog.TitleContainer>
      <div>
        <StyledIdrConfirmDialog.ContentContainer>
          <StyledIdrConfirmDialog.Text>{text}</StyledIdrConfirmDialog.Text>
        </StyledIdrConfirmDialog.ContentContainer>
        <StyledDialog.Actions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button
            color="primary"
            variant="contained"
            type="button"
            onClick={() => handleSubmit(form)}>
            Aceptar
          </Button>
        </StyledDialog.Actions>
      </div>
    </CustomDialog>
  );
};

export default IdrConfirmDialog;
